
/**
 * <auto-generated>
 *     This code was generated by a tool.
 *
 *     Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
 * </auto-generated>
 */ 

export const NmdpSite = { 
    TemplateIds: {
        
        BaseDisease : "05A72766A2204D23BC3AB9E35CDC872D",
        BaseDiseaseData : "1FC2C7982D58450592DACE153427DB5A",
        BroadDisease : "628E6FFFF2624EA3BDDC3D6086278BFF",
        Center : "46E180F57A9648BF9A7B060E98D8FA10",
        CenterFolder : "FF8CF3233C4247C0BB562C6488DC06A0",
        CenterContact : "38E9C0C1CD1448A1B6CB8286D908E8D0",
        ContactFolder : "316A48AE9E4445069990BEFB09B70C74",
        Disease : "012319D55D3944F6AB337A923A703DCA",
        DiseaseFolder : "32CD01A051A5401E8E57657D01A0A808",
        DiseaseStage : "0FC2C20634154E56A1C0071DD6EC5AC3",
        DoubleTheDonation : "FA705F997D584392919A1B668F9C05AF",
        Eligibility : "CC40AB07850441E5B894069CDB0A972E",
        EligibilityFolder : "4A6EA1B34BC54C359C0D849285FF1316",
        Listing : "717F55AE997F4F759829886B99E7F4C4",
        ListingDiseaseTxStats : "9DC53BE5D79E4E6C9FAA8E5B7D021710",
        ListingTxTotals : "D4C53507264F41A9B3903C608C77BA70",
        Program : "B09F5B5151D8450397A797D17AFC3001",
        ProgramFolder : "B42DA32D08E941FCA10522084B791ED6",
        SurvivalAnalysisFolder : "48307E0551BA4DB7AA14AE12C28F3B15",
        SurvivalAnalysis : "CABA8974A54A4DEDA80839DDB3E05C35",
        TxTypeStats : "C25C099D0F6740B4A540106A855A43A6"    
    }
}


